import 'antd/dist/antd.css';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './assets/fonts';
import './assets/material-design-iconic-font/css/material-design-iconic-font.min.css'


import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();